import { render, staticRenderFns } from "./Huevo.vue?vue&type=template&id=e4b0a892&scoped=true&"
import script from "./Huevo.vue?vue&type=script&lang=js&"
export * from "./Huevo.vue?vue&type=script&lang=js&"
import style0 from "./Huevo.vue?vue&type=style&index=0&id=e4b0a892&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4b0a892",
  null
  
)

export default component.exports